import axios from "axios";

const RESOLUTION_SVC_URL = process.env.REACT_APP_RESOLUTION_SVC_URL || "http://localhost:8880";
const RESOLUTION_SVC_AUTH =
  process.env.REACT_APP_RESOLUTION_SVC_AUTH || "Basic YXN0cm9uYWNjaTpBc3RyMG5hY2NpQDIwMjY=";

export const axiosResolution = axios.create({
  baseURL: RESOLUTION_SVC_URL,
  headers: {
    Authorization: RESOLUTION_SVC_AUTH,
    "Content-Type": "application/json",
  },
});

export default axiosResolution;
